import { parseIdFilter } from "../../../handlers/filter";
import { IdFilterRequiredError, NotImplementedError, publisherRollupToServicePublisherRollupRequest, servicePublisherRollupToPublisherRollup } from "../../../types";
import { ObservableHandler } from "../../../utils";
import { Observable } from "rxjs";
import axios from "axios";
import PublisherSettings from "../publisherSettings";
import { validators } from "./validators";
class PublisherRollups extends ObservableHandler {
    constructor(sdk) {
        super(sdk, "publishers-rollups", { atomize: true });
        this.validators = validators(this.sdk);
        this.toPublisherRollup = (rollup) => {
            return servicePublisherRollupToPublisherRollup(rollup);
        };
        this.url = `${this.sdk.urls.baseAPIUrl}/rollup`;
        this.publisherSettings = new PublisherSettings(this.sdk);
        this.validators = validators(sdk);
    }
    findItems(filters) {
        return new Observable((subscriber) => {
            const [idFilter] = parseIdFilter(filters);
            if (!idFilter) {
                throw new IdFilterRequiredError();
            }
            const promise = this.getPublisherRollUp(idFilter.toString());
            promise
                .then((rollup) => {
                subscriber.next(rollup);
                subscriber.complete();
            })
                .catch((error) => {
                subscriber.error(error);
            });
        });
    }
    async getPublisherRollUp(id) {
        return this.cache.promise(id, () => axios
            .get(`${this.sdk.urls.baseAPIUrl}/publisher-rollup/${id}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((res) => this.toPublisherRollup(res.data.data)));
    }
    /**
     * This saveItem method will be used as a POST in smithers, since the rollup endpoint does not support `saving`
     * We will use the saveItem method to POST the data to the rollup endpoint
     *    madSDK.publishers.publisherSettings.save(data)
     */
    saveItem(data) {
        return new Observable((subscriber) => {
            const payload = this.toServiceRequest(data);
            axios
                .post(`${this.url}`, payload, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
                .then(({ data: res }) => {
                const result = this.toPublisherRollup(res.data);
                subscriber.next(result);
                subscriber.complete();
            })
                .catch((error) => {
                subscriber.error(error);
            });
        });
    }
    toServiceRequest(rollup) {
        return publisherRollupToServicePublisherRollupRequest(rollup);
    }
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    make(rollup) {
        throw new NotImplementedError("make");
    }
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    async deleteItem(id) {
        throw new NotImplementedError("delete");
    }
}
export default PublisherRollups;
//# sourceMappingURL=index.js.map